import gql from "graphql-tag";

const typeDefs = gql`
    type UserUploads {
        deniedCount: Int!
        pendingCount: Int!
        hasApprovedUploads: Bool!
    }

    type UserUploadsResponse {
        ok: Bool!
        errors: [String]
        photos: UserUploads
        icons: UserUploads
    }

    extend type Query {
        currentUserUploads: UserUploadsResponse!
    }
`;

export default typeDefs;
